// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wJAL","textarea":"styles_textarea__1GvIA"};